/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {SidebarData} from './SidebarData';
import SubMenu from './SubMenu';
import {IconContext} from 'react-icons/lib';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight'
import {theme} from "../../../constants/theme";
import {BiUserPlus} from "react-icons/bi";
import {ARGOS_ROUTES} from "../../../Routes/constants";
import useGetCurrentPath from "../../../hooks/useGetCurrentPath";
import Argos_Logo from "../../images/ar_white.png";
import ArgosFlexbox from '../Containers/ArgosFlexbox';
import BoxWithCenteredContent from "../Containers/BoxWithCenteredContent";
import * as RiIcons from 'react-icons/ri';
import {RiAdminLine, RiExternalLinkLine} from 'react-icons/ri';
import {ARGOS_TEST_FRONTEND_DOMAIN} from "../../../constants/globalVariables";
import {usePostRequest} from "../../../api/helper";

const SidebarNav = styled.nav`
    background: ${theme.layout.sidebar.backgroundColor};
    height: ${theme.layout.sidebar.height};
    display: flex;
    flex-flow: column nowrap;
    width: ${({isSidebarCollapsed}) => (isSidebarCollapsed ? theme.layout.sidebar.collapsedWidth : theme.layout.sidebar.expandedWidth)};

    transition: ${theme.layout.sidebar.collapseTransition};
`;

const SidebarBody = styled.div(props => ({
  display: 'flex',
  flexFlow: 'column nowrap',
  flexGrow: 1
}))

const SidebarFooter = styled.div`
    cursor: pointer;
    padding: 5px 10px;
`;

const SidebarCollapseButton = styled.button`
    color: ${theme.layout.sidebar.footer.collapseButton.color};
    background-color: transparent;

    &:hover {
        background-color: ${theme.layout.sidebar.footer.collapseButton.hoverColor};
    }

    border: none;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const shouldShowSidebar = (route) => {
  const val = ARGOS_ROUTES.find(item => item.path === route)
  return val?.sidebar ?? false
}

const Sidebar = () => {
  const [version, setVersion] = useState("")
  useEffect(() => {
    fetchVersion()
  }, [])
  const fetchVersionHandle = usePostRequest("/HttpTriggerVersion")
  const fetchVersion = async () => {
    fetchVersionHandle().then((data) => {
      setVersion(data)
    }).catch(err => {
      console.log(err)
    })
  }
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const currentPath = useGetCurrentPath()
  const showSidebar = shouldShowSidebar(currentPath)
  let subNav = [
    {
      title: 'User Accounts',
      path: '/admin',
      cName: 'sub-nav',
      icon: <BiUserPlus style={{
        height: "50px",
        width: "30px",
      }}/>,
    },
    {
      title: 'Source Code Docs',
      extLink: '/html/index.html',
      cName: 'sub-nav',
      icon: <RiExternalLinkLine style={{
        height: "50px",
        width: "30px",
      }}/>
    },
  ]
  //console.log(window.location.origin);
  if (window.location.origin != ARGOS_TEST_FRONTEND_DOMAIN && window.location.origin != "http://localhost:3000") {
    subNav.splice(1, 1);
  }
  return (
    <>
      {showSidebar && (
        <IconContext.Provider value={{color: '#fff'}}>
          <SidebarNav isSidebarCollapsed={isSidebarCollapsed} style={{overflow: 'auto'}}>
            <SidebarBody>
              <div style={{
                marginLeft: "0px",
                width: "100%",
                height: theme.layout.header.height,
                display: 'flex',
                flexDirection: 'column'
              }}>
                <div style={{paddingLeft: '12px', display: "flex", alignItems: "center", flex: 1}}>
                  <ArgosFlexbox vertical>
                    <a href="./landing" style={{paddingRight: "20px"}}>
                      <div style={{display: "flex", flexDirection: "column"}}>
                        <img style={{
                          height: '65px',
                          width: '50px',
                        }} src={Argos_Logo}/>

                      </div>
                    </a>
                  </ArgosFlexbox>

                  {!isSidebarCollapsed &&
                    <div style={{
                      paddingLeft: "20px",
                      paddingRight: "65px",
                      flexGrow: 0.5,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center"
                    }}>
                      <BoxWithCenteredContent style={{color: "white", fontSize: "30px", width: '100%'}}>Argos</BoxWithCenteredContent>
                      <div style={{textAlign: 'center', justifyContent: "left", fontSize: 15, color: 'white', paddingRight: 5}}>
                        {version}
                      </div>
                    </div>
                  }

                  {/*<hr color="white" width="1" size={'80'} height={'80%'} style={{opacity: 1}}/>*/}
                </div>
                {/*<hr color="white" width="80%"*/}
                {/*    style={{opacity: 1, margin: "0rem", alignSelf: "center", marginLeft: "0px", color: "white"}}/>*/}
                <div style={{height: '1px', backgroundColor: 'white', width: '80%', alignSelf: 'center'}}></div>
              </div>

              {SidebarData.map((item, index) => {
                return <SubMenu item={item} key={index} isSidebarCollapsed={isSidebarCollapsed}/>;
              })}
            </SidebarBody>
            <SubMenu
              item={{
                title: 'Admin',
                icon: <RiAdminLine style={{
                  padding: ' 5px',
                  height: '50px',
                  width: '40px',
                  marginLeft: '-7px',
                }}/>,
                iconClosed: <RiIcons.RiArrowDownSFill/>,
                iconOpened: <RiIcons.RiArrowUpSFill/>,
                subNav: subNav
              }}
              key={0}
              isSidebarCollapsed={isSidebarCollapsed}
            />
            <SidebarFooter>
              <SidebarCollapseButton onClick={() => setIsSidebarCollapsed(prevState => !prevState)}>
                {isSidebarCollapsed ? <KeyboardDoubleArrowRightIcon/> : <KeyboardDoubleArrowLeftIcon/>}
              </SidebarCollapseButton>
            </SidebarFooter>
          </SidebarNav>
        </IconContext.Provider>
      )}
    </>
  );
};

export default Sidebar;
